module.exports = "/static/assets/00730b4c9ce1009bf4028f722f77475b.png";